// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import {
    DispatchBeginLoadProduct,
    DispatchCompleteLoadProduct,
    InitVariantProduct,
    LoadExistingProduct,
    LoadProductIfNeeded,
    LoadRealTimePricingAndInventory,
    PrepareProduct,
    SetUnitOfMeasureAndQtyOrdered,
    SetupVariantSelection,
    TrackInOdp,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { CustomRequestVariantChildrenFromApi } from "@mcmc/App/Handlers/Pages/ProductDetails/DisplayProduct";

export const CustomLoadProductIfNeeded: typeof LoadProductIfNeeded = async props => {
    // if variantTypeId is not null this has variantTraits, and we need those loaded fully for this handler chain to work correctly
    if (props.product && props.product.variantTypeId === null) {
        if (!props.product.variantTraits) {
            // we don't want to wait for this if we already partially have the product, because then we can't show the partially loaded product page
            props.dispatch(
                loadProductByPath({
                    ...props.parameter,
                }),
            );
        }

        return;
    }

    props.product = await executeAwaitableHandlerChain(loadProductByPath as any, props.parameter as any, props);
};

export const chain = [
    DispatchBeginLoadProduct,
    LoadExistingProduct,
    CustomLoadProductIfNeeded,
    CustomRequestVariantChildrenFromApi,
    SetupVariantSelection,
    SetUnitOfMeasureAndQtyOrdered,
    DispatchCompleteLoadProduct,
    TrackInOdp,
    LoadRealTimePricingAndInventory,
    InitVariantProduct,
    PrepareProduct,
];

const loadEvent = createHandlerChainRunner(chain, "LoadEvent");
export default loadEvent;
